<template lang="pug">
shListData(title="Diseños" resolver="designs" keyData="design" component="shDesign")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Designs',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/design/Designs.vue